module.exports = __webpack_public_path__ + "img/hotTag.c2d945d6.gif";